/**
 * Hook for fetching credit note queries using clean architecture
 * @param documentId - Credit note document ID
 */
import { useQueriesBySource } from "../../../../shared/queries/presentation/hooks/useQueriesBySource";

export const useCreditNoteQueries = (documentId: string | null) => {
  const { queries, loading, loadingMore, error, refetch, hasMore, loadMore } =
    useQueriesBySource(
      "credit_note",
      documentId ? parseInt(documentId) : undefined
    );

  return { queries, loading, loadingMore, error, refetch, hasMore, loadMore };
};

